<template>
	<div>
		<v-card v-if="list_type && contents">
			<v-toolbar flat>
        <v-btn icon small 
          @click="toggle_pin(content_list.id)"
          v-if="!$compact_view()"
        >
          <v-icon color="deep-orange" v-if="is_pinned">push_pin</v-icon>
          <v-icon v-else>push_pin</v-icon>
        </v-btn>
				<v-toolbar-title style="margin-left: 0px;">{{content_list.name}}</v-toolbar-title>
        <v-btn v-if="$is_admin() && !$compact_view() && !disableImport" @click.stop="open_import()" >Import {{disableImport}}</v-btn>
        <v-btn v-if="is_import_json" @click.stop="open_json_import()">Import JSON</v-btn>
        <v-btn v-if="$is_admin() && !$compact_view() && !disableImport" @click.stop="open_multi_upload()" >Upload files</v-btn>
			</v-toolbar>
			<v-data-table v-model="selected" :headers="headers" :items="contents" :search="search" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
        <template v-slot:headers="props">
          <tr>
            <th v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])">
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['text-xs-'+header.align, 'column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
            <template v-if="header.value == 'actions' && $is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])">
              <v-btn left flat icon 
                @click.stop="changeSelectedItemsState('active')" 
                :disabled="selected.length == 0 || list_type.fields['disable_hide/show']"
              >
                <v-badge class="overlap2" overlap v-show="!list_type.fields['disable_hide/show']">
                  <template v-slot:badge>
                    <span v-if="selected.length > 0">{{selected.length}}</span>
                  </template>
                  <v-icon>visibility</v-icon>
                </v-badge>
              </v-btn>
              <v-btn left flat icon 
                @click.stop="changeSelectedItemsState('archived')" 
                :disabled="selected.length == 0"
                v-show="!list_type.fields['disable_hide/show']"
              >
                <v-badge class="overlap2" overlap>
                  <template v-slot:badge>
                    <span v-if="selected.length > 0">{{selected.length}}</span>
                  </template>
                  <v-icon>visibility_off</v-icon>
                </v-badge>
              </v-btn>
              <v-btn left flat color="red" icon @click.stop="delete_selected_items()" :disabled="selected.length == 0">
                <v-badge class="overlap2" overlap>
                  <template v-slot:badge>
                    <span v-if="selected.length > 0">{{selected.length}}</span>
                  </template>
                  <v-icon>delete</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <template v-else>
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </template>
            </th>
          </tr>
        </template>
  	   	<template slot="items" slot-scope="props">
  	   		<tr :active="props.selected" @click="props.selected = !props.selected"><!-- @click.stop="open_data(props.item.id)">-->
            
          <td v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])">
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
  	   		<td @click.stop="open_data(props.item.id)">{{props.item.id}}</td>

          <template v-for="field in fields">

            <td v-if="field.type != 'file' && field.type != 's3file' && field.type != 'multiline'">
              <v-edit-dialog lazy @save="save_inplace(props.item, field)">
                <span v-html="get_data(props.item.data, field)"></span>
                <template v-slot:input>
                  <v-layout row>
                      <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="props.item.data" :ref="field.name"></component>
                      <v-btn flat left color="green" @click.stop="save_inplace(props.item, field)">Save</v-btn>
                  </v-layout>
                </template>
              </v-edit-dialog>
            </td>

            <td v-else @click.stop="open_data(props.item.id)">
              <span v-html="get_data(props.item.data, field)"></span>
            </td>

          </template>

  	   		<td style="text-align: right;">
            <v-btn left flat icon 
              v-show="props.item.state != 'archived' && !list_type.fields['disable_hide/show']" 
                @click.stop="changeItemState(props.item, 'archived')"
            ><v-icon>visibility</v-icon></v-btn>
            <v-btn left flat icon 
              v-show="props.item.state == 'archived' && !list_type.fields['disable_hide/show']" 
              @click.stop="changeItemState(props.item, 'active')"
            ><v-icon>visibility_off</v-icon></v-btn>
             <v-btn left flat icon @click.stop="open_data(props.item.id)"><v-icon>edit</v-icon></v-btn>
  	   			 <v-btn left flat color="red" icon @click.stop="delete_item(props.item)" v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"><v-icon>delete</v-icon></v-btn>
  	   		</td>
  	   		</tr>
    	  </template>
      </v-data-table>
    </v-card>

    <BottomSheet v-if="$compact_view()"></BottomSheet>

	</div>
</template>

<script>
import Vue from 'vue'
import ContentModel from '@/models/content.js'
import datelib from '@/lib/date.js'
import BottomSheet from '../BottomSheet'

import * as FormItems from '@/components/form_items'

export default {
	props: ["id", "list","search", "editpath", "disable-import"],
	data () {
		return {
			channel: undefined,
			list_data: {},
      pagination: {
        sortBy: 'identifier',
        descending: false,
        rowsPerPage: 25
      },
      selected: []
		}
	},
  components: {
    ...FormItems,
    BottomSheet
  },
  watch: {
    "id": function(newValue) {
      this.reconnect();
    },
    "list": function(newValue) {
      this.reconnect();
    }
  },
	computed: {
		headers () {
			var ret = [{ text: 'Id', value: 'id', align: 'left' }];
			_.each(this.fields, (field) => {
				ret.push({ text: (field.label || field.title), value: 'data.' + field.name, align: 'left', sortable: true});
			});
			ret.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false});
			return ret;
		},
		content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.get_list_id();
      });
    },
    fields () {
      var lt = this.list_type;
      if (typeof(lt.fields["list-fields"]) != "undefined") {
        return _.filter(lt.fields["fields"], function(field) {
          return lt.fields["list-fields"].includes(field["name"]);
        })

      }

      return lt.fields["fields"];
    },
    list_type () {
      var cl = this.content_list;
      if (typeof(cl) != "undefined" && cl != null) {
        return _.find(this.list_types, (lt) => {
          return lt.id == cl.cms_list_type_id;
        });
      }
    },
    is_import_json () {
      if (this.$is_privilege('developer')) return true;
      if (typeof(this.list_type.fields) != "undefined") {
        return this.list_type.fields.import_json || false;
      }
      return false;
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
		contents () {
			return Object.values(this.list_data);
		},
    is_pinned() {
      let lists = _.get(this.$store.state.account, 'meta.cms_pinned_lists', []);
      if(lists.indexOf(this.content_list.id) > -1) return true;
      return false;
    }
	},
	mounted() {
		this.connect_ws();
    this.$store.dispatch("get_profile");
	},
 	beforeDestroy: function() {
    this.channel.leave();
  },
	methods: {
    get_list_id() {
      return this.list || this.id;
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.contents.slice()
    },
    toggle_pin(id) {
      if (!this.$store.state.account) return;
      let acc = _.cloneDeep(this.$store.state.account);
      acc.meta.cms_pinned_lists = _.xor(acc.meta.cms_pinned_lists, [id]);
      this.$store.dispatch("update_profile", acc);
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    changeItemState (item, state) {
      item.state = state;
      this.save_inplace(item, "state");
    },
    changeSelectedItemsState(state) {
      var promises = _.map(this.selected, (item) => {
        return new Promise((resolve, reject) => {
          item.state = state;
          this.save_inplace(item, "state", true, resolve, reject);
        });
      });
      Promise.allSettled(promises).then((results) => {
        if(_.countBy(results, (r) => { return r.status })["fulfilled"] == promises.length) {
          this.$message.success("List data was updated!");
        } else {
          this.$message.warning("Unable to update list data!");
        }
      });
    },
    save_inplace (item, field, hide_messages, success, failed) {
      var self = this;

      if (typeof(this.channel) != "undefined") {
        // Prepare save data for send
        let send_list_data = _.cloneDeep(item);
        send_list_data.cms_list_id = self.get_list_id();

        this.channel
          .push("save", {list_data: send_list_data})
          .receive("ok", (msg) => {
              if(!hide_messages) self.$message.success("List data was updated!");
              if(_.isFunction(success)) success(msg);
          })
          .receive("error", (msg) => {
            console.log(msg);
            if(!hide_messages) self.$message.warning("Unable to update list data!");
            if(_.isFunction(failed)) failed(msg);
          });
      }
    },


		get_data (item, field) {
			var data = item[field.name];
			if (field.type == "list_select") {
				var cl = this.$store.state.cms_lists[data];
				if (typeof(cl) != "undefined") return cl.name;
				return data;
			}

      if (field.type == "file") {
        if (typeof data === 'undefined' || data === "") { return "" }

        // Migrate 's3file' type field data for display
        let url = data
        if (typeof data === 'Object' || data instanceof Object) {
          url = _.get(data, "url", "")
        }

        if (field["content-type"] == "image") return "<img style='height: 20px;' src='" + url + "'>"
      }

      // Get S3 file field values from JSON
      if (field.type == "s3file") {
        if (typeof data === 'undefined' || data === "") { return "" }

        let dataString = ""

        // Migrate 'file' type field data for display
        let url = _.get(data, "url", "")
        let statusCode = _.get(data, "status", "")
        let statusMessage = _.get(data, "statusMessage", "")

        if (typeof data === 'string' || data instanceof String) {
          url = data
          statusCode = "ready"
          statusMessage = ""
        }

        if (field["content-type"] == "image") {
          dataString = '<img style="height: 20px;" src="' + url + '"> '
        }

        dataString += '<span title="' + statusMessage + '">' + statusCode + '</span>'

        return dataString
      }

      if (field.type == "multiline") {
        return "Multiline"
      }
      if (field.type == "datetime") {
        return datelib.format_date(data) +" - "+datelib.format_time(data);
      }
      if (field.type == "date") {
        return datelib.format_date(data);
      }
      if (field.type == "content_select") {
        if (typeof(data) != "undefined") {
          if (typeof(data) == "string") return data;
          return data["name"] || "";
        } else {
          return "";
        }
      }
      if (field.type == "playoff_tree") {
        return "-";
      }
      if (field.type == "checkbox") {
        if(data) {
          return field["true-text"] || '<i aria-hidden="true" class="v-icon fa fa-'+(field["true-icon"]||'check')+' theme--dark"></i>';
        } else {
          return field["false-text"] || '<i aria-hidden="true" class="v-icon fa fa-'+(field["false-icon"])+' theme--dark"></i>';
        }
      }
      if(field.type == "text" && _.startsWith(data, "http")) {
        return "<a class='light-blue--text text--lighten-4' href='"+data+"' target='_blank' onclick='return false;' ondblclick='window.location = this.href;'>"+data+"</a>";
      }
			return data;
		},
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    edit_path_prefix () {
      if (typeof(this.editpath) == "undefined") return "/content/list/";
      return this.editpath;
    },

		open_data (id) {
			this.$router.push(this.edit_path_prefix() + this.get_list_id() + "/data/edit/"+id);
		},
    open_add_data () {
      this.$router.push("/content/list/"+this.id+"/data/new");
    },
    open_import () {
      this.$router.push(this.edit_path_prefix() + this.get_list_id() + "/data/import");
    },
    open_multi_upload () {
      this.$router.push(this.edit_path_prefix() + this.get_list_id() + "/data/multi_upload");
    },
    open_json_import () {
      this.$router.push(this.edit_path_prefix() + this.get_list_id() + "/data/json_import");
    },
		delete_item (item, hide_messages, success, failed) {
			var self = this;
			this.channel.push("delete", {list_data: item})
      	.receive("ok", (msg) => {
      		if(!hide_messages) self.$message.success("List data deleted!");
          Vue.delete(self.list_data, msg.id);
          if(_.isFunction(success)) success(msg);
        })
        .receive("error", (msg) => {
        	console.log(msg);
        	if(!hide_messages) self.$message.warning("Cannot remove list data");
          if(_.isFunction(failed)) failed(msg);
        });
		},
    delete_selected_items(hide_messages, success, failed) {
      var self = this;
      this.channel.push("delete", {list_data_ids: _.map(this.selected, (item) => { return item.id; })})
        .receive("ok", (msg) => {
          if(!hide_messages) self.$message.success("Selected list items deleted!");
          _.each(msg.list_datas, (deleted_item) => {
            Vue.delete(self.list_data, deleted_item.id);
          })
          if(_.isFunction(success)) success(msg);
        })
        .receive("error", (msg) => {
          console.log(msg);
          if(!hide_messages) self.$message.warning("CCannot remove selected list items!");
          if(_.isFunction(failed)) failed(msg);
        });

    },
    reconnect() {
      this.channel.off("init");
      this.channel.off("update");
      this.channel.off("delete");
      this.channel.leave();
      this.list_data = {};
      this.selected = [];
      this.connect_ws();
    },
		connect_ws () {
      var self = this;
      this.channel = this.$cloudserver.channel("cms:list_datas:"+this.get_list_id());
      this.channel.on("init", function(msg) {
      	msg.list_data.forEach(function(d) {
      		Vue.set(self.list_data, d.id, d);
      	});
      });
      this.channel.on("update", function(msg) {
        console.log("List data update", msg);
      	Vue.set(self.list_data, msg.list_data.id, msg.list_data);
      });
      this.channel.on("delete", function(msg) {
        console.log("List data delete", msg);
				Vue.delete(self.list_data, msg.list_data.id);
      });
      this.channel.join();
    }
	}
}
</script>
<style >
  .v-badge--overlap.overlap2 .v-badge__badge {
    top: -12px;
    right: -12px;
  }
</style>
